<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="7" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">系统信息管理</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-camera"></i></div>
      <div class="gerenxinxi">系统信息管理</div>
    </div>
    <div class="head01">
      <Header :activeIndex="7" v-if="!isMobile" />
      <div class="head02">
        <div class="neirong">
          <div class="juli">
            <span class="span">*手机号：</span><el-input placeholder="输入手机号" prefix-icon="el-icon-phone" v-model="phoneNumber"
              class="kuandu" :disabled="isDisabled" @blur="validatePhoneNumber">
            </el-input>
          </div>
          <div class="msg" v-show="rightPhone">{{ phonemsg }}</div>
          <div class="juli">
            <span class="span">*密码：</span><el-input placeholder="输入密码" prefix-icon="el-icon-lock" v-model="password"
              class="kuandu" show-password :disabled="isDisabled">
            </el-input>
          </div>
          <div class="juli">
            <span class="span">*确认密码：</span><el-input placeholder="再次确认密码" prefix-icon="el-icon-lock" v-model="password2"
              class="kuandu" show-password :disabled="isDisabled">
            </el-input>
          </div>
          <div class="msg" v-show="isDisabled === false && password2 !== '' && password !== password2">{{ msg }}</div>
          <div class="juzhong" v-if="!isDisabled">
            <div class="save" @click="save">保存信息</div>
          </div>
        </div>
        <div v-if="isDisabled" class="footer">
          <div class="qvxiao" @click="update">修改</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header.vue';
import Footer from './Footer.vue'
export default {
  name: 'usersystem',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      phoneNumber: '',
      password: '',
      password2: '',
      isDisabled: false,
      id: sessionStorage.getItem("userId"),
      BASE_URL: 'https://zhiyedashi.com/info',
      // BASE_URL: 'http://192.168.2.8:8206',
      msg: '两次密码不一致',
      isMobile: false,
      rightPhone: false,
      phonemsg: "请输入正确的手机号"
    }
  },
  created() {
    // 1. 判断关键数据是否存在
    if (!this.id) {
      // 2. 提前返回，跳过后续所有代码
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
  },
  mounted() {
    this.selectUserLogin()
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  methods: {
    validatePhoneNumber() {
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.phoneNumber)) {
        this.rightPhone = true
      } else {
        this.rightPhone = false
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    save() {
      // 保存/修改信息
      // 先判断两次密码是否一致
      if (!this.rightPhone) {
        if (this.isDisabled === false && this.password === this.password2) {
          let userLogin = {
            id: this.id,
            phoneNumber: this.phoneNumber,
            password: this.password
          }
          fetch(`${this.BASE_URL}/admin/user/login/updateUserLogin`, {
            method: 'post',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(userLogin)
          })
            .then(res => res.json())
            .then(data => {
              // console.log("修改成功", data);
              if (data.code === 200 && data.data === "修改成功") {
                this.$router.replace('/');
                window.location.reload(true);
              } else {
                alert("网络有波动，请稍后再试")
              }
            })
            .catch(error => {
              console.error("修改失败，原因是", error);
            })
        } else {
          // 两次密码不一致
          if (this.isDisabled === true) {
            alert("数据未发生改变")
          } else {
            alert("密码不一致，请重新输入")
          }
        }
      } else {
        alert("请输入正确的手机号")
      }
    },
    update() {
      this.isDisabled = false
    },
    selectUserLogin() {
      // console.log("id是多少", this.id);
      fetch(`${this.BASE_URL}/admin/user/login/selectById`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${this.id}`
      })
        .then(res => res.json())
        .then(data => {
          // console.log("data数据", data);
          if (data.data === '用户信息不存在') {
            this.isDisabled = false
          } else {
            this.phoneNumber = data.data.phoneNumber
            this.password = data.data.password
            this.isDisabled = true
          }
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    }
  }
}
</script>

<style>
.el-input.is-disabled .el-input__inner {
  border: none !important;
  color: #000000 !important;
  font-size: 17px !important;
}

.el-textarea.is-disabled .el-textarea__inner {
  border: none !important;
  color: #000000 !important;
  font-size: 17px !important;
}
</style>

<style scoped>
.juli {
  display: flex;
  margin-top: 20px;
  margin-left: 20px;
}

.span {
  display: block;
  width: 108px;
  padding: 5px;
}

.msg {
  color: red;
  font-size: 14px;
  padding: 8px 5px;
}

.juzhong {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 100px;
}

.kuandu {
  width: 300px;
}

.hengtiao1 {
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
}

.hengtiao {
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.head01 {
  display: flex;
  gap: 100px;
}

.head02 {
  display: flex;
  gap: 30px;
}

.neirong {
  display: flex;
  gap: 30px;
  margin-top: 30px;
  margin-left: 100px;
  flex-direction: column;
  width: 560px;
}

.save {
  background-color: #3572e5;
  height: 40px;
  width: 200px;
  border-radius: 10px;
  color: white;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
}

.qvxiao {
  border: 3px solid #bfc3ce;
  color: #2e323d;
  height: 40px;
  width: 200px;
  border-radius: 10px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.footer {
  margin-top: 42px;
}

@media (max-width: 768px) {
  .logo {
    width: 50px;
  }

  .juli {
    margin-left: 0px;
    margin-top: 10px;
  }

  .span {
    width: 32%;
    padding: 4px;
  }

  .msg {
    font-size: 12px;
    padding: 6px 4px;
  }

  .juzhong {
    gap: 20px;
    flex-direction: column;
  }

  .kuandu {
    width: 220px;
  }

  .head01 {
    gap: 10px;
    flex-direction: column;
    padding-top: 140px;
  }

  .head02 {
    flex-direction: column;
    gap: 20px;
  }

  .neirong {
    margin-left: 0px;
    width: 100%;
    gap: 15px;
    margin-top: 10px;
  }

  .save {
    width: 46%;
    margin-top: 10px;
  }

  .qvxiao {
    width: 46%;
    margin-top: 10px;
  }

  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/usersystem.vue